import useAuthToken from '../useAuthToken';
import {countries, CountryCodeType} from '../../model';
import useQueryState from '../useQueryState';

export const useCountry = () => {
  const [value, setValue] = useQueryState<CountryCodeType>(
    ['country-code'],
    'SE',
  );

  // if authenticated use value from token
  const token = useAuthToken();
  const code = token?.country ?? value ?? 'SE';
  const country = countries[code];

  return {
    ...country,
    setValue,
    formatNumber: (number?: number) => {
      if (typeof number === 'number' && Number.isFinite(number)) {
        return Intl.NumberFormat(country.locale).format(number);
      }
      return '-';
    },
  };
};

export default useCountry;
